import { AA, Resource, Method } from 'sdk';
import HelpActions from './HelpActions';

class HelpActionCreator {
  getHelp(currentNodeId, params) {
    const hierarchyRequest = AA.api(Resource.helpNodeHierarchy, Method.get, params);
    const currentNodeRequest = AA.api(Resource.helpNode(currentNodeId), Method.get, params);

    HelpActions.getHelpStarted();
    Promise.all([hierarchyRequest, currentNodeRequest]).then((responses) => {
      HelpActions.getHelpSucceeded(
        { nodeHierarchy: responses[0].data, currentNode: responses[1].data },
      );
    }, (error) => {
      HelpActions.getHelpFailed(error);
    });
  }
}

export default new HelpActionCreator();
